import { useState } from 'react';
import DropdownButton from '../../basics/DropdownButton';
import ExportLayerKmlButton, {
  ExportLayerKmlButtonProps,
} from './ExportLayerKmlButton';
import ExportLayerJsonButton from './ExportLayerJsonButton';

const filetypeOptions = ['JSON', 'KML'].map((name) => ({ name }));

const LayerExportButtons = (props: ExportLayerKmlButtonProps) => {
  const [filetype, setFiletype] = useState(
    // Default to KML option, but fall back on first option to resolve TS warnings
    filetypeOptions.find((option) => option.name === 'KML') ||
      filetypeOptions[0],
  );
  return (
    <>
      <div className="d-flex align-items-center mb-1">
        <DropdownButton
          color="light"
          options={filetypeOptions}
          selectedOption={filetype.name}
          setOption={setFiletype}
          showOverflow
        />
      </div>
      {filetype.name === 'JSON' && <ExportLayerJsonButton {...props} />}
      {filetype.name === 'KML' && <ExportLayerKmlButton {...props} />}
    </>
  );
};

export default LayerExportButtons;
